/**
 * WCAG 2.3.3 — honour `prefers-reduced-motion` for map camera moves.
 *
 * CSS animations are already neutralised in tokens.css; deck.gl fly-to
 * transitions are JS, so the call sites (App.tsx `flyTo`, lens changes) must
 * wrap their `transitionDuration` with this.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** `ms` normally; 0 (jump cut) when the user asked for reduced motion. */
export function motionDuration(ms: number): number {
  return prefersReducedMotion() ? 0 : ms;
}
